import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';

import { ConfirmDialogComponent } from '../../../shared-module/components/_modals/modal-confirm-dialog/confirm-dialog.component';

@Injectable()
export class DeleteDialogService {
  constructor(public dialog: MatDialog) {}

  public show(header: string = '', isToShow: boolean = true): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {});
    dialogRef.componentInstance.header = header;
    dialogRef.componentInstance.isQuestionShown = isToShow;

    return dialogRef.afterClosed();
  }
}
